import React from "react"
import { Cursor } from "../../elements"
import styled from "styled-components"

const AboutCursor = ({ xValue, yValue }) => {
  return (
    <About top={yValue} left={xValue} height="150" width="150" zIndex="999999">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 145 145"
      >
        <path
          className="st0"
          d="M76.1,17.2L84,28.7c1.1,1.6,3.2,2.3,5,1.6l13.1-4.7c2.9-1,5.9,1.2,5.8,4.2l-0.4,13.9c-0.1,2,1.2,3.7,3.1,4.3
	L124,52c2.9,0.9,4.1,4.4,2.2,6.8l-8.5,11c-1.2,1.6-1.2,3.7,0,5.3l8.5,11c1.9,2.4,0.7,6-2.2,6.8l-13.4,3.9c-1.9,0.6-3.2,2.3-3.1,4.3
	l0.4,13.9c0.1,3.1-2.9,5.2-5.8,4.2L89,114.7c-1.9-0.7-3.9,0-5,1.6l-7.9,11.5c-1.7,2.5-5.4,2.5-7.2,0L61,116.3
	c-1.1-1.6-3.2-2.3-5-1.6l-13.1,4.7c-2.9,1-5.9-1.2-5.8-4.2l0.4-13.9c0.1-2-1.2-3.7-3.1-4.3L21,93c-2.9-0.9-4.1-4.4-2.2-6.8l8.5-11
	c1.2-1.6,1.2-3.7,0-5.3l-8.5-11c-1.9-2.4-0.7-6,2.2-6.8l13.4-3.9c1.9-0.6,3.2-2.3,3.1-4.3l-0.4-13.9c-0.1-3.1,2.9-5.2,5.8-4.2
	L56,30.3c1.9,0.7,3.9,0,5-1.6l7.9-11.5C70.6,14.7,74.4,14.7,76.1,17.2z"
        />
        <g>
          <path
            className="st0"
            id="sparkle_1"
            d="M136.8,24.4c-0.6,0.3-1.3,0.6-1.9,0.8c-6.4,1.5-6.3,1.4-7.5,8c-0.1,0.6-0.5,1.2-0.7,1.7c-0.2,0-0.4,0-0.6,0
		c-0.3-1.1-0.7-2.1-0.8-3.2c-0.4-3.8-2.5-5.7-6.2-5.8c-0.5,0-1.1-0.1-1.5-0.3c-0.4-0.1-0.6-0.6-0.9-0.8c0.3-0.2,0.5-0.6,0.8-0.7
		c1.1-0.3,2.1-0.6,3.2-0.8c2.3-0.5,3.6-1.9,4-4.2c0.2-1.2,0.4-2.3,0.7-3.4c0.1-0.4,0.5-0.7,0.8-1c0.3,0.3,0.7,0.6,0.8,0.9
		c0.3,1.1,0.5,2.1,0.8,3.2c0.5,2.4,1.9,3.7,4.3,4.1c1.6,0.2,3.2,0.6,4.8,0.9C136.7,24,136.8,24.2,136.8,24.4z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_2"
            d="M104.9,13.8c4.2-0.1,5.7-2.7,6.4-6.1c0.7,1.5,1,3.4,2.2,4.4c1.1,1,3,1.1,5.2,1.7c-2.1,0.8-4.1,0.9-5.1,2
		c-1.1,1.1-1.2,3.1-2,5.3c-0.7-1.9-0.9-3.8-1.9-4.8c-1-1.1-2.9-1.3-4.3-1.9C105.1,14.1,105,13.9,104.9,13.8z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_3"
            d="M18.3,126.2c4.2-0.1,5.7-2.7,6.4-6.1c0.7,1.5,1,3.4,2.2,4.4c1.1,1,3,1.1,5.2,1.7c-2.1,0.8-4.1,0.9-5.1,2
		c-1.1,1.1-1.2,3.1-2,5.3c-0.7-1.9-0.9-3.8-1.9-4.8c-1-1.1-2.9-1.3-4.3-1.9C18.5,126.6,18.4,126.4,18.3,126.2z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_4"
            d="M121.3,7.4c1.6,0,2.2-1,2.5-2.4c0.3,0.6,0.4,1.3,0.9,1.7c0.4,0.4,1.2,0.4,2,0.7c-0.8,0.3-1.6,0.4-2,0.8
		c-0.4,0.4-0.5,1.2-0.8,2.1c-0.3-0.8-0.3-1.5-0.7-1.9c-0.4-0.4-1.1-0.5-1.7-0.8C121.4,7.6,121.3,7.5,121.3,7.4z"
          />
        </g>
        <g>
          <path
            id="sparkle_5"
            className="st0"
            d="M12.3,119.9c1.6,0,2.2-1,2.5-2.4c0.3,0.6,0.4,1.3,0.9,1.7c0.4,0.4,1.2,0.4,2,0.7c-0.8,0.3-1.6,0.4-2,0.8
		c-0.4,0.4-0.5,1.2-0.8,2.1c-0.3-0.8-0.3-1.5-0.7-1.9c-0.4-0.4-1.1-0.5-1.7-0.8C12.4,120,12.4,119.9,12.3,119.9z"
          />
        </g>
        <g>
          <path
            className="st5"
            d="M55.1,49.9c0-0.1,0.1-0.2,0.2-0.2h1.9c0.2,0,0.3,0.1,0.3,0.2l1.9,6.4h0.1l1.8-6.4c0-0.1,0.1-0.2,0.3-0.2h1.9
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2v-7.1h-0.1l-1.3,4.9c0,0.1-0.1,0.2-0.2,0.2h-1
		c-0.1,0-0.2-0.1-0.2-0.2l-1.3-4.9h-0.1v7.1c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2V49.9z"
          />
          <path
            className="st5"
            d="M66.8,49.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V49.9z"
          />
          <path
            className="st5"
            d="M75.2,49.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V49.9z"
          />
          <path
            className="st5"
            d="M85.5,62c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H85.5z"
          />
          <path
            className="st5"
            d="M62,79c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H62z"
          />
          <path
            className="st5"
            d="M68.9,66.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1h-1.7c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V66.9z"
          />
          <path
            className="st5"
            d="M78.7,66.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V66.9z"
          />
          <path
            className="st5"
            d="M49.4,83.9c0-0.1,0.1-0.2,0.2-0.2h3.1c2.3,0,3.3,1,3.3,3.2c0,1.5-0.5,2.3-1.4,2.6v0c0.9,0.3,1.5,1.1,1.5,2.8
		c0,2.7-1.2,3.6-3.6,3.6h-2.9c-0.1,0-0.2-0.1-0.2-0.2V83.9z M52.4,88.7c0.9,0,1.2-0.3,1.2-1.5c0-1.2-0.3-1.5-1.2-1.5h-0.5
		c-0.1,0-0.1,0-0.1,0.1v2.8c0,0.1,0,0.1,0.1,0.1H52.4z M51.8,94h0.5c1,0,1.3-0.4,1.3-1.7c0-1.3-0.3-1.7-1.3-1.7h-0.5
		c-0.1,0-0.1,0-0.1,0.1v3.1C51.7,93.9,51.8,94,51.8,94z"
          />
          <path
            className="st5"
            d="M58.8,92.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1v-9
		c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C60,96.1,58.8,94.9,58.8,92.6z"
          />
          <path
            className="st5"
            d="M68.4,83.9c0-0.1,0.1-0.2,0.2-0.2h2.3c0.1,0,0.2,0.1,0.3,0.2l2,7.7h0.1v-7.7c0-0.1,0.1-0.2,0.2-0.2h1.7
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2H73c-0.1,0-0.2-0.1-0.3-0.2l-2.1-7.7h-0.1v7.7c0,0.1-0.1,0.2-0.2,0.2h-1.7
		c-0.1,0-0.2-0.1-0.2-0.2V83.9z"
          />
          <path
            className="st5"
            d="M78.2,89.8c0-3.2,0.1-3.7,0.2-4.2c0.4-1.3,1.4-2,3-2c2,0,3.1,1,3.2,3.1c0,0.1,0,0.2-0.2,0.2l-1.9,0.3
		c-0.1,0-0.2,0-0.2-0.2c0-1-0.3-1.4-0.9-1.4c-0.4,0-0.7,0.2-0.8,0.6c-0.1,0.3-0.1,0.5-0.1,3.6c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.4,0.6,0.8,0.6c0.6,0,0.9-0.4,0.9-1.3c0-0.1,0.1-0.2,0.2-0.2l1.9,0.3c0.1,0,0.2,0.1,0.2,0.2c-0.1,2.1-1.3,3.1-3.2,3.1
		c-1.6,0-2.6-0.7-3-2C78.3,93.6,78.2,93,78.2,89.8z"
          />
          <path
            className="st5"
            d="M87.3,83.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1h-1.7c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V83.9z"
          />
          <path
            className="st5"
            d="M97.7,92.4l-0.5-8.5c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2l-0.5,8.5c0,0.1-0.1,0.2-0.2,0.2h-1.1
		C97.8,92.6,97.7,92.5,97.7,92.4z M97.3,93.7c0-0.1,0.1-0.2,0.2-0.2h1.8c0.1,0,0.2,0.1,0.2,0.2v2.1c0,0.1-0.1,0.2-0.2,0.2h-1.8
		c-0.1,0-0.2-0.1-0.2-0.2V93.7z"
          />
        </g>
        <g>
          <path
            className="st11"
            d="M53.1,47.9c0-0.1,0.1-0.2,0.2-0.2h1.9c0.2,0,0.3,0.1,0.3,0.2l1.9,6.4h0.1l1.8-6.4c0-0.1,0.1-0.2,0.3-0.2h1.9
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2v-7.1h-0.1l-1.3,4.9c0,0.1-0.1,0.2-0.2,0.2h-1
		c-0.1,0-0.2-0.1-0.2-0.2l-1.3-4.9h-0.1v7.1c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2V47.9z"
          />
          <path
            className="st11"
            d="M64.8,47.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V47.9z"
          />
          <path
            className="st11"
            d="M73.2,47.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V47.9z"
          />
          <path
            className="st11"
            d="M83.5,60c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H83.5z"
          />
          <path
            className="st11"
            d="M60,77c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2h6.4c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H60z"
          />
          <path
            className="st11"
            d="M66.9,64.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1h-1.7c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V64.9z"
          />
          <path
            className="st11"
            d="M76.7,64.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V64.9z"
          />
          <path
            className="st11"
            d="M47.4,81.9c0-0.1,0.1-0.2,0.2-0.2h3.1c2.3,0,3.3,1,3.3,3.2c0,1.5-0.5,2.3-1.4,2.6v0c0.9,0.3,1.5,1.1,1.5,2.8
		c0,2.7-1.2,3.6-3.6,3.6h-2.9c-0.1,0-0.2-0.1-0.2-0.2V81.9z M50.4,86.7c0.9,0,1.2-0.3,1.2-1.5c0-1.2-0.3-1.5-1.2-1.5h-0.5
		c-0.1,0-0.1,0-0.1,0.1v2.8c0,0.1,0,0.1,0.1,0.1H50.4z M49.8,92h0.5c1,0,1.3-0.4,1.3-1.7c0-1.3-0.3-1.7-1.3-1.7h-0.5
		c-0.1,0-0.1,0-0.1,0.1v3.1C49.7,91.9,49.8,92,49.8,92z"
          />
          <path
            className="st11"
            d="M56.8,90.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1
		v-9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C58,94.1,56.8,92.9,56.8,90.6z"
          />
          <path
            className="st11"
            d="M66.4,81.9c0-0.1,0.1-0.2,0.2-0.2h2.3c0.1,0,0.2,0.1,0.3,0.2l2,7.7h0.1v-7.7c0-0.1,0.1-0.2,0.2-0.2h1.7
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2H71c-0.1,0-0.2-0.1-0.3-0.2l-2.1-7.7h-0.1v7.7c0,0.1-0.1,0.2-0.2,0.2h-1.7
		c-0.1,0-0.2-0.1-0.2-0.2V81.9z"
          />
          <path
            className="st11"
            d="M76.2,87.8c0-3.2,0.1-3.7,0.2-4.2c0.4-1.3,1.4-2,3-2c2,0,3.1,1,3.2,3.1c0,0.1,0,0.2-0.2,0.2l-1.9,0.3
		c-0.1,0-0.2,0-0.2-0.2c0-1-0.3-1.4-0.9-1.4c-0.4,0-0.7,0.2-0.8,0.6c-0.1,0.3-0.1,0.5-0.1,3.6c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.4,0.6,0.8,0.6c0.6,0,0.9-0.4,0.9-1.3c0-0.1,0.1-0.2,0.2-0.2l1.9,0.3c0.1,0,0.2,0.1,0.2,0.2c-0.1,2.1-1.3,3.1-3.2,3.1
		c-1.6,0-2.6-0.7-3-2C76.3,91.6,76.2,91,76.2,87.8z"
          />
          <path
            className="st11"
            d="M85.3,81.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1h-1.7c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V81.9z"
          />
          <path
            className="st11"
            d="M95.7,90.4l-0.5-8.5c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2l-0.5,8.5c0,0.1-0.1,0.2-0.2,0.2h-1.1
		C95.8,90.6,95.7,90.5,95.7,90.4z M95.3,91.7c0-0.1,0.1-0.2,0.2-0.2h1.8c0.1,0,0.2,0.1,0.2,0.2v2.1c0,0.1-0.1,0.2-0.2,0.2h-1.8
		c-0.1,0-0.2-0.1-0.2-0.2V91.7z"
          />
        </g>
      </svg>
    </About>
  )
}

export default AboutCursor

const About = styled(Cursor)`
  .st0 {
    fill: #eed36c;
  }
  .st1 {
    fill: #83c8b6;
  }
  .st2 {
    fill: #e14263;
  }
  .st3 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5538;
    stroke-miterlimit: 10;
  }
  .st4 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5614;
    stroke-miterlimit: 10;
  }
  .st5 {
    fill: #ffffff;
  }
  .st6 {
    fill: #c5934c;
  }
  .st7 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5091;
    stroke-miterlimit: 10;
  }
  .st8 {
    fill: #0000ff;
  }
  .st9 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5797;
    stroke-miterlimit: 10;
  }
  .st10 {
    fill: #e22651;
  }
  .st11 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st12 {
    fill: none;
    stroke: #db6780;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st13 {
    fill: #e5a13d;
  }
  .st14 {
    fill: #0d2e33;
  }
  .st15 {
    fill: #b2c4aa;
  }
  .st16 {
    fill: none;
    stroke: #e92e55;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st17 {
    fill: none;
    stroke: #e4af53;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st18 {
    fill: none;
    stroke: #10363c;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st19 {
    fill: none;
    stroke: #c4d1bf;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }

  #sparkle_1,
  #sparkle_2,
  #sparkle_3,
  #sparkle_4,
  #sparkle_5 {
    opacity: 0;
    animation: appear 0.5s infinite;
  }

  #sparkle_1 {
    animation-delay: 0;
  }

  #sparkle_2 {
    animation-delay: 0.1s;
  }
  #sparkle_3 {
    animation-delay: 0.15s;
  }

  @keyframes appear {
    0% {
      opacity: 0;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

`
